module.exports = __webpack_public_path__ + "static/media/construction.dec760f5.jpg";